import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'toggle-button',
  templateUrl: 'toggle-button.component.html',
  styleUrls: ['toggle-button.component.scss'],
})
export class ToggleButtonComponent {
  @Input() collapsedText: string = 'Show more';

  @Input() expandedText: string = 'Show less';

  @Input() expanded: boolean = false;

  get text(): string {
    return this.expanded ? this.expandedText : this.collapsedText;
  }
}
